<app-loader></app-loader>
<app-toaster></app-toaster>

<router-outlet></router-outlet>
